import { ReplicaType } from "types";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp6-bridge-collapse-death-toll-rises-alternative",
  name: `The Daily Prophet\n'Bridge Collapse: Death Toll Rises' (alternative)`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'Bridge Collapse: Death Toll Rises' (alternative)",
  },
  origin: "Harry Potter and the Half-Blood Prince",

  category: replicaCategories.harryPotter,

  versions: [Version2],
};

export default data;
